// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`RecentInvoice general snapshot 1`] = `
<div class="recent-invoice">
  <invoicestatusbar-stub status="processing" class="row"></invoicestatusbar-stub>
  <invoicewithactionslayout-stub></invoicewithactionslayout-stub>
</div>
`;
